export const types = {
  normal: {
    name: 'Normal',
    color: '#A8A878'
  },
  fighting: {
    name: 'Lutador',
    color: '#C03028'
  },
  flying: {
    name: 'Voador',
    color: '#A890F0'
  },
  poison: {
    name: 'Venenoso',
    color: '#A040A0'
  },
  ground: {
    name: 'Terrestre',
    color: '#E0C068'
  },
  rock: {
    name: 'Pedra',
    color: '#B8A038'
  },
  bug: {
    name: 'Inseto',
    color: '#A8B820'
  },
  ghost: {
    name: 'Fantasma',
    color: '#705898'
  },
  steel: {
    name: 'Metálico',
    color: '#B8B8D0'
  },
  fire: {
    name: 'Fogo',
    color: '#F08030'
  },
  water: {
    name: 'Água',
    color: '#6890F0'
  },
  grass: {
    name: 'Planta',
    color: '#78C850'
  },
  electric: {
    name: 'Elétrico',
    color: '#F8D030'
  },
  psychic: {
    name: 'Psiquico',
    color: '#F85888'
  },
  ice: {
    name: 'Gelo',
    color: '#98D8D8'
  },
  dragon: {
    name: 'Dragão',
    color: '#7038F8'
  },
  dark: {
    name: 'Noturno',
    color: '#705848'
  },
  fairy: {
    name: 'Fada',
    color: '#EE99AC'
  },
  unknown: {
    name: '???',
    color: '#68A090'
  },
  shadow: {
    name: 'Shadow',
    color: '#000000'
  }
}
